import React, { useEffect } from "react";

import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";

import { useDispatch, useSelector } from "react-redux";
import { Box, Typography } from "@material-ui/core";
import MarathonRequests from "services/marathon";
import MarathonScoreTableHeading from "./MarathonScoreTableHeading";
import MarathonScoreTableItem from "./MarathonScoreTableItem";
import Pagination from "@material-ui/lab/Pagination";
import { animateScroll as scroll } from "react-scroll";

const MarathonScoreTable = ({ searchMode, searchInput }) => {
  const dispatch = useDispatch();
  const {
    marathonScores,
    marathonScoresCurrentPage,
    marathonScoresTotalPages,
  } = useSelector(({ tests }) => tests);

  useEffect(() => {
    dispatch(MarathonRequests.getMarathonScores(1, searchInput));
  }, [searchMode, searchInput]);

  const handleChangePagination = (_, value) => {
    if (searchMode) {
      dispatch(MarathonRequests.getMarathonScores(value, searchInput));
    } else {
      dispatch(MarathonRequests.getMarathonScores(value));
    }
    scroll.scrollToTop();
  };

  return (
    <div className="Cmt-table-responsive">
      {marathonScores &&
        (marathonScores.length === 0 ? (
          <Box
            display={"flex"}
            justifyContent={"center"}
            paddingTop={"30px"}
            paddingBottom={"20px"}
          >
            <Typography variant="h3">موردی برای نمایش وجود ندارد</Typography>
          </Box>
        ) : (
          <Table>
            <TableHead>
              <MarathonScoreTableHeading />
            </TableHead>
            <TableBody>
              {marathonScores.map((item) => (
                <MarathonScoreTableItem
                  data={item}
                  key={item._id}
                />
              ))}
            </TableBody>
          </Table>
        ))}
      {marathonScores.length !== 0 ? (
        <Box display={"flex"} justifyContent={"center"} marginTop={"20px"}>
          <Pagination
            count={marathonScoresTotalPages}
            color="primary"
            page={marathonScoresCurrentPage}
            onChange={handleChangePagination}
          />
        </Box>
      ) : null}
    </div>
  );
};

export default MarathonScoreTable;
